var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.xieYiList),function(item,index){return _c('van-cell',{key:index,attrs:{"title":'《'+item.name+'》',"is-link":""},on:{"click":function($event){return _vm.goToUrl(item.url)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }